import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Modal, ModalHeader, ModalTitle, ModalClose, ModalBody} from 'react-modal-bootstrap';
import * as companyActions from '../../../actions/companyActions';
import * as spinnerActions from '../../../actions/spinnerActions';
import Select from 'react-select';
import ReactSelectFormatter from "../../../services/ReactSelectFormatter";
import CustomModal from "../../CustomModal";
import SpinnerButton from "../../common/SpinnerButton";
import { injectIntl } from 'react-intl';
import {messages} from  '../../common/Translations';


class CompanyCategoryRestrictionModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: [],
        };

        this.categoryIds = [];
    }

    componentWillReceiveProps(newProps) {
        if(!newProps.companyCategoryRestrictionModal.show) {
            this.state.value = [];
            this.categoryIds = [];
        }
    }

    onChange(value) {
        if(this.props.companyCategoryRestrictionModal.count && value.length > this.props.companyCategoryRestrictionModal.count) {
            value = value.slice(0, this.props.companyCategoryRestrictionModal.count);
        }

        this.categoryIds = ReactSelectFormatter.getIds(value);
        this.setState({value});
    }

    handleConfirm(e) {
        let {
            companyId,
            count,
            countSwitcherSelect,
        } = this.props.companyCategoryRestrictionModal;

        if(!this.categoryIds.length) {
            this.categoryIds = [0];
        }
    }

    render() {
        let {
            companyCategoryRestrictionModal,
        } = this.props;

        return <CustomModal
            isOpen={companyCategoryRestrictionModal.show}
            handleHideModal={this.props.actions.hideCompanyCategoryRestrictionModal}
            modalTitle={this.props.intl.formatMessage(messages.chooseCategories)}
            modalContent={
                <Select
                    {...this.props}
                    value={this.state.value}
                    options={ReactSelectFormatter.format(companyCategoryRestrictionModal.companyCategories)}
                    onChange={this.onChange.bind(this)}
                    multi={true}
                    clearable={false}
                />
            }
            closeText={this.props.intl.formatMessage(messages.deleteModalCancelButton)}
            confirmButton={<SpinnerButton
                title="Konfirmere"
                type="button"
                id="company-category-change-submit"
                className='btn btn-primary clickable modal-yes'
                onClick={this.handleConfirm.bind(this)}
            />}
        />
    }

}

function mapStateToProps(state, ownProps) {
    return {
        companyCategoryRestrictionModal: state.companyCategoryRestrictionModal,
        companies: state.companies,
    };
}

function mapDispatchToProps(dispatch) {


    return {
        actions: bindActionCreators(Object.assign(
            {},
            companyActions,
            spinnerActions,
        ), dispatch)
    }

}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(CompanyCategoryRestrictionModal));


// WEBPACK FOOTER //
// ./web/src/components/company/list/CompanyCategoryRestrictionModal.jsx